import PropTypes from 'prop-types'
import { formatearFecha } from '../helpers/helper'
import Imagen from '../imagen/Imagen'
import styles from './SelectorItemsPedido.module.css'

export const SelectorItemsPedido = ({
  items,
  seleccionados,
  onToggle,
  errorSinSeleccion,
  bloqueados = [],
  onSeleccionarTodos
}) => {
  const desbloqueados = items.filter((item) => !bloqueados.includes(item.idPedidoItem))
  const todosSeleccionados =
    desbloqueados.length > 0 &&
    desbloqueados.every((item) => seleccionados.includes(item.idPedidoItem))
  return (
    <div className={styles.contenedor}>
      <h3 className={styles.titulo}>Seleccioná los productos a actualizar</h3>
      {errorSinSeleccion && (
        <p className={styles.sinSeleccion}>Debe seleccionar al menos un producto.</p>
      )}
      {desbloqueados.length > 1 && (
        <button
          className={`${styles.btnSeleccionarTodos} ${todosSeleccionados ? styles.btnDeseleccionar : ''}`}
          onClick={onSeleccionarTodos}
          type="button"
        >
          {todosSeleccionados ? 'Deseleccionar todos' : 'Seleccionar todos'}
        </button>
      )}
      <div className={styles.grilla}>
        {items.map((item) => {
          const seleccionado = seleccionados.includes(item.idPedidoItem)
          const bloqueado = bloqueados.includes(item.idPedidoItem)
          return (
            <div
              key={item.idPedidoItem}
              className={`${styles.tarjeta} ${seleccionado && !bloqueado ? styles.tarjetaSeleccionada : ''} ${bloqueado ? styles.tarjetaBloqueada : ''}`}
              onClick={() => !bloqueado && onToggle(item.idPedidoItem)}
            >
              {seleccionado && !bloqueado && <span className={styles.check_badge} />}
              <div className={styles.imagen_wrapper}>
                <Imagen idPublicacion={item.idPublicacion} />
              </div>
              <div className={styles.info}>
                <div className={styles.titulo_item}>{item.titulo}</div>
                {(item.estadoNombre || item.nombreEstado) && (
                  <div className={styles.estado_badge}>
                    {item.estadoNombre || item.nombreEstado}
                  </div>
                )}
                <div className={styles.datos}>
                  {item.cantidad && (
                    <span className={styles.dato}>
                      <span className={styles.dato_label}>Cantidad:</span> {item.cantidad}
                    </span>
                  )}
                  {item.precioUnitario !== null && (
                    <span className={styles.dato}>
                      <span className={styles.dato_label}>Precio:</span> ${item.precioUnitario}
                    </span>
                  )}
                  {item.precioEnvio !== null && item.precioEnvio > 0 && (
                    <span className={styles.dato}>
                      <span className={styles.dato_label}>Envío:</span> ${item.precioEnvio}
                    </span>
                  )}
                  {item.entregaLocalidadDesc && (
                    <span className={styles.dato}>
                      <span className={styles.dato_label}>Localidad:</span>{' '}
                      {item.entregaLocalidadDesc}
                    </span>
                  )}
                  {item.entregaCalle && (
                    <span className={styles.dato}>
                      <span className={styles.dato_label}>Dirección:</span>
                      {item.entregaCalle} {item.entregaCalleAltura}
                      {item.entregaPiso ? `, piso ${item.entregaPiso}` : ''}
                      {item.entregaDpto ? ` dto. ${item.entregaDpto}` : ''}
                    </span>
                  )}
                  {item.fechaPedido && (
                    <span className={styles.dato}>
                      <span className={styles.dato_label}>Pedido:</span>{' '}
                      {formatearFecha(item.fechaPedido, 'F')}
                    </span>
                  )}
                  {item.fechaDespachado && (
                    <span className={styles.dato}>
                      <span className={styles.dato_label}>Despachado:</span>{' '}
                      {formatearFecha(item.fechaDespachado, 'F')}
                    </span>
                  )}
                  {item.fechaRecibido && (
                    <span className={styles.dato}>
                      <span className={styles.dato_label}>Recibido:</span>{' '}
                      {formatearFecha(item.fechaRecibido, 'F')}
                    </span>
                  )}
                </div>
                {bloqueado && (
                  <div className={styles.bloqueado_msg}>Ya tiene este estado o uno posterior</div>
                )}
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

SelectorItemsPedido.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      idPedidoItem: PropTypes.number.isRequired,
      idPublicacion: PropTypes.number.isRequired,
      titulo: PropTypes.string,
      estadoNombre: PropTypes.string,
      nombreEstado: PropTypes.string
    })
  ).isRequired,
  seleccionados: PropTypes.arrayOf(PropTypes.number).isRequired,
  onToggle: PropTypes.func.isRequired,
  errorSinSeleccion: PropTypes.bool,
  bloqueados: PropTypes.arrayOf(PropTypes.number),
  onSeleccionarTodos: PropTypes.func
}
